module.exports = __webpack_public_path__ + "assets/img/events-calendar-button.3add97b0.png";